export function calcDailyPaceNeeded(
  units: number,
  goal: number,
  daysLeft: number,
  isPeriodClosed: boolean
): number | undefined {
  if (goal === 0) return undefined;
  if (daysLeft > 0) return Math.ceil(Math.max(0, goal - units) / daysLeft);
  if (isPeriodClosed) return 0;
  return undefined;
}
